import { createGenericSlice } from './createGenericSlice.js'
import { isIterable } from '../../_helpers/jsHelper.js'
import { serialize } from '../../_helpers/firestoreHelper.js'

const initialState = {
  aircrafts: [],
  airports: [],
  availabilities: [],
  items: [],
  tests: [],
  users: [],
}

const slice = createGenericSlice({
  name: 'firestore',
  initialState,
  reducers: {
    success: {
      reducer: (state, { payload }) => {
        state[payload.collection] = payload.data
      },
      prepare: (collection, data) => ({
        payload: {
          collection,
          data: isIterable(data)
            ? data.map(serialize)
            : serialize(data),
        },
      }),
    },
  },
})

export const actions = slice.actions
export default slice.reducer
